import React from 'react';
import {connect} from 'react-redux';
import {getUserIdentity} from "state/app/selectors";

class UserIdentityReport extends React.Component {
  static getAppInfoTableData(userIdentity) {
    return [
      { title: "App Version", value: `${userIdentity.appVersion} / ${process.env.REACT_APP_PACKAGE_VERSION}` },
      { title: "OS",          value: `${userIdentity.os} / ${userIdentity.osVersion}` },
      { title: "Platform",    value: userIdentity.platform },
      { title: "Device",      value: userIdentity.device }
    ];
  }

  render() {
    const appInfoTableData = UserIdentityReport.getAppInfoTableData(this.props.userIdentity);
    const { cssBlockName } = this.props;
    return (
        <table className={cssBlockName}>
          <tbody>
            {
              appInfoTableData.map( (item, index) => {
                  return (
                    <tr key={index}>
                      <td className={`${cssBlockName}__title`}>{item.title}</td>
                      <td className={`${cssBlockName}__value`}>{item.value}</td>
                    </tr>
                  )
              })
            }
          </tbody>
        </table>
    )
  }
}

export default connect(
  (state, ownProps) => ({
    userIdentity: getUserIdentity(state).toJS()
  })
)(UserIdentityReport)



// WEBPACK FOOTER //
// ./src/components/app/AppInfoTable.js